<script>
export default {
  name: 'AdvertiseImage',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Object,
      required: true,
    },

    link: {
      type: String,
      required: true,
    }
  },

  methods: {
    bannerClick() {
      this.$ma.trackEvent({
        category: 'loginAdClick',
        properties: {
          releaseVersion: this.$store.state.version.system,
        },
      })
    }
  },

}
</script>

<template>
  <a
    v-if="visible"
    :href="link"
    :title="image.alt"
    target="_blank"
    class="advertise"
    @click="bannerClick"
  >
    <img
      :src="image.src"
      :alt="image.alt"
    />
  </a>
</template>


<style scoped>
.advertise {
  display: none;
  margin-top: -1px;
  margin-bottom: -1px;
}

img {
  max-width: 400px;
  max-height: 655px
}
@media (min-width: 1000px) {
  .advertise {
    display: flex;
    outline: none;
  }
}
</style>
